import React from 'react'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import withScriptjs from 'react-google-maps/lib/async/withScriptjs'

const Map = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      ref={props.onMapLoad}
      zoomControl={false}
      defaultZoom={15}
      defaultCenter={props.center}
      options={props.mapConfig}
    >
      <Marker position={props.center} />
    </GoogleMap>
  ))
)

export default Map



// WEBPACK FOOTER //
// ./src/components/shared/GoogleMap.js